export const setIsLoading = (accountData) => async (dispatch) => {
    dispatch({ type: 'SET_IS_LOADING', payload: accountData });
};
